<template>
    <div>
        <Head title="Види риболовлі без місця"/>
        <h1 class="mb-8 text-3xl font-bold">Види риболовлі без місця</h1>
        <div class="flex items-center justify-between mb-6">
            <Link
                class="btn-indigo"
                :href="$route('f-types.create')"
            >
                <span>Створити</span>
                <span class="hidden md:inline"> новий вид</span>
            </Link>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">Назва</th>
                    <th class="pb-4 pt-6 px-6">Ліміт на день</th>
                    <th class="pb-4 pt-6 px-6">Ціна</th>
                    <th class="pb-4 pt-6 px-6">Озеро</th>
                </tr>
                <tr v-for="fast_order_type in fast_order_types.data" :key="fast_order_type.id"
                    class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <Link
                            class="flex items-center px-6 py-4 focus:text-indigo-500"
                            :href="$route('f-types.edit', fast_order_type.id)"
                            tabindex="-1"
                        >
                            {{ fast_order_type.name }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link
                            class="flex items-center px-6 py-4 focus:text-indigo-500"
                            :href="$route('f-types.edit', fast_order_type.id)"
                            tabindex="-1"
                        >
                            {{ fast_order_type.day_limit }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link
                            class="flex items-center px-6 py-4 focus:text-indigo-500"
                            :href="$route('f-types.edit', fast_order_type.id)"
                            tabindex="-1"
                        >
                            {{ fast_order_type.price }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link
                            class="flex items-center px-6 py-4 focus:text-indigo-500"
                            :href="$route('f-types.edit', fast_order_type.id)"
                            tabindex="-1"
                        >
                            {{ fast_order_type.lake_name }}
                        </Link>
                    </td>
                    <td class="w-px border-t">
                        <Link
                            class="flex items-center px-6 py-4 focus:text-indigo-500"
                            :href="$route('f-types.edit', fast_order_type.id)"
                            tabindex="-1"
                        >
                            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
                        </Link>
                    </td>
                </tr>
                <tr v-if="fast_order_types.data.length === 0">
                    <td class="px-6 py-4 border-t" colspan="4">Немає жодного запису</td>
                </tr>
            </table>
        </div>
        <pagination class="mt-6" :links="fast_order_types.links"/>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'

export default {
    components: {
        Head,
        Icon,
        Link,
        Pagination,
    },
    layout: Layout,
    props: {
        fast_order_types: Object
    },
}
</script>
